import React, { useState, useEffect } from 'react';
import './IntroOverlay.css';
import riyadhVideo from '../../../../assets/Riyadh.webm';
import logo from '../../../../assets/Asset 2.svg';

const STORAGE_KEY = 'ae_intro_seen';

const IntroOverlay = () => {
  const [phase, setPhase] = useState(() => {
    if (typeof window === 'undefined') return 'done';
    // Require width AND a fine pointer (mouse/trackpad) AND hover support
    // This excludes all phones, tablets, and touch-primary devices
    const isDesktop = window.matchMedia(
      '(min-width: 1024px) and (hover: hover) and (pointer: fine)'
    ).matches;
    const alreadySeen = sessionStorage.getItem(STORAGE_KEY);
    if (!isDesktop || alreadySeen) return 'done';
    sessionStorage.setItem(STORAGE_KEY, '1');
    return 'visible';
  });

  useEffect(() => {
    if (phase !== 'visible') return;

    document.body.style.overflow = 'hidden';

    // Overlay fades after EN → AR → logo sequence completes
    const fadeTimer = setTimeout(() => setPhase('fading'), 4800);
    const doneTimer = setTimeout(() => {
      document.body.style.overflow = '';
      setPhase('done');
    }, 6000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
      document.body.style.overflow = '';
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (phase === 'done') return null;

  return (
    <div className={`intro-overlay${phase === 'fading' ? ' intro-overlay--fading' : ''}`}>
      <video autoPlay muted playsInline className="intro-overlay__video">
        <source src={riyadhVideo} type="video/webm" />
      </video>

      <div className="intro-overlay__gradient" />
      <div className="intro-overlay__vignette" />

      <div className="intro-overlay__content">
        {/* English — in, then fades out */}
        <div className="intro-overlay__headline intro-overlay__headline--en">
          <span className="intro-overlay__word intro-overlay__word--en-1">Building</span>
          <span className="intro-overlay__word intro-overlay__word--en-2">
            <em>The Future</em>
          </span>
        </div>

        {/* Arabic — fades in after EN is gone, then fades out */}
        <div className="intro-overlay__headline intro-overlay__headline--ar" dir="rtl">
          <span className="intro-overlay__word intro-overlay__word--ar-1">نبني</span>
          <span className="intro-overlay__word intro-overlay__word--ar-2">
            <em>المستقبل</em>
          </span>
        </div>

        {/* Logo — fades in after AR is gone */}
        <div className="intro-overlay__logo-wrap">
          <img src={logo} alt="Advanced Elements" className="intro-overlay__logo" />
        </div>
      </div>
    </div>
  );
};

export default IntroOverlay;
